import { userModelServer, edgeServer } from '../api_client/apiClient';
const client_key = "64JXMJSDr30ZjGCOETjP7SH2F4zLmYR2orOnXh3b7RrKuC9w76fgH3pes25CB5ISxf6j23GXZq4Dq6QDsHNQXcYYLFCgJ10vtQF2IAPCZX4OY85VZ2JikYtr2XQJ2fMA";

export function login(email, password){
  let formData = new FormData();
  formData.append('email', email);
  formData.append('password', password);
  formData.append('client_key', client_key);

  return (dispatch) =>{

    userModelServer.post('auth/signin', formData)
    .then((response)=>{
      if(response.data.status === true){
        edgeServer.get(
          'console/courses',
          {headers:{'Authorization': 'Bearer '+response.data.token}}
        ).then((res)=>{
          dispatch({
            type: 'COURSES_FULFILLED',
            payload: res.data.data,
            jwt: response.data.token
          })
        }).catch((err)=>{
          dispatch({
            type: 'COURSES_REJECTED',
            error: err
          })
        })

      } else{
        dispatch({
          type: 'LOGIN_REJECTED',
          payload: response.data.message
        })
      }
    })
    .catch((error)=>{
      dispatch(({
        type: 'LOGIN_REJECTED',
        payload: error
      }))
    })
  };
}

export function tryLogin(isLoggedIn){
  var key = document.cookie.split(';')
    .find(d => d.split('=')[0].trim() === 'session_token');

  if (typeof key === 'undefined' ) {
    window.location.href = `https://usermodel.themusio.com/login?next=${window.location.href}`;
  }else{
    var sessionId = key.split('=')[1];
    var formData = new FormData();
    formData.append('session_token', sessionId);
    formData.append('client_key', client_key);
    return (dispatch)=>{
      userModelServer.post('auth/signin/token', formData)
      .then(response=>{
        dispatch({
          type: 'LOGIN_FULFILLED',
          payload: response.data.token
        })
      })
    }
  }
}

export function getCourses(){
  return (dispatch, getState)=>{
    edgeServer.get('console/courses')
    .then((res)=>{
      dispatch({
        type:'COURSES_FULFILLED',
        payload: res.data.data,
      })
    })
  }
}

export function setRedirectUrl(currentUrl){
    return (dispatch) =>{
    dispatch({
      type: "REDIRECT_URL",
      payload: currentUrl
    });
  };
}

export function setContent(courseId){
  return(dispatch)=>{
    dispatch({
      type: "SET_CONTENT",
      payload: courseId
    })
  }
}

export function logout(){
  return(dispatch)=>{
    dispatch({
      type: "LOGOUT"
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/AuthAction.js